import { useWindowDimensions } from 'react-native';

import { DESKTOP_SIDEBAR_TOTAL_WIDTH } from '../constants/layout';
import { isDesktopWeb } from '../utils/platformDetection';

/**
 * Width actually available to a screen's content, given the window width.
 *
 * On desktop web `app/(app)/_layout.tsx` puts a fixed-width `DesktopSidebar`
 * to the left of every screen, so the window overstates the content column by
 * the width of that rail.
 */
export function contentWidthFor(windowWidth: number, desktop: boolean): number {
  return desktop ? Math.max(0, windowWidth - DESKTOP_SIDEBAR_TOTAL_WIDTH) : windowWidth;
}

/**
 * Width available to the current screen's content.
 *
 * Grids sized off `useWindowDimensions()` lay out a column that the right edge
 * of the window clips, because the desktop sidebar is not part of their box.
 * Use this instead whenever a layout divides the screen into columns.
 */
export function useContentWidth(): number {
  const { width } = useWindowDimensions();
  // Same condition as the `desktop` branch in app/(app)/_layout.tsx, so the
  // two can't drift apart.
  return contentWidthFor(width, isDesktopWeb());
}
